import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../../theme/palette";
import { View } from "../../View";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row-reverse",
    padding: "16px",
    marginTop: "10px",
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const CopyDriverWorkScheduleActions = ({
  disable,
  onCancel,
  onContinue,
}) => {
  const styles = useStyles();
  return (
    <View className={styles.container}>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={onContinue}
        disabled={disable}
      >
        Copy
      </Button>
      <Button
        className={styles.yellow}
        variant={"contained"}
        onClick={onCancel}
      >
        Cancel
      </Button>
    </View>
  );
};
